import React, { useEffect, useState } from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Shield, Award, Clock, Users, Loader2 } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const About = () => {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const response = await fetch(`${API}/about`);
        if (response.ok) {
          const data = await response.json();
          setContent(data);
        }
      } catch (error) {
        console.error('Error loading about content:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchContent();
  }, []); // Empty dependency array is correct here - only fetch on mount

  const features = [
    {
      icon: Shield,
      title: "Garantía en Reparaciones",
      description: "Todas nuestras reparaciones cuentan con garantía de 30 días."
    },
    {
      icon: Award,
      title: "Técnicos Certificados",
      description: "Profesionales capacitados en las últimas tecnologías."
    },
    {
      icon: Clock,
      title: "Servicio Rápido",
      description: "La mayoría de reparaciones se completan en 24-48 horas."
    },
    {
      icon: Users,
      title: "Atención Personalizada",
      description: "Cada cliente recibe un trato único y profesional."
    }
  ];

  if (loading) {
    return (
      <div className="min-h-screen py-20 px-4 flex items-center justify-center">
        <Loader2 className="h-12 w-12 text-cyan-400 animate-spin" />
      </div>
    );
  }

  return (
    <div className="min-h-screen py-20 px-4">
      <div className="container mx-auto">
        {/* Header */}
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h1 className="text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-cyan-400 to-emerald-400 bg-clip-text text-transparent">
            {content?.title || "Sobre KROLBOLT"}
          </h1>
          <p className="text-xl text-slate-300 leading-relaxed">
            {content?.content || "Somos especialistas en reparación de tecnología con años de experiencia en el mercado."}
          </p>
        </div>

        {/* Mission and Vision */}
        {(content?.mission || content?.vision) && (
          <div className="max-w-4xl mx-auto mb-16 grid grid-cols-1 md:grid-cols-2 gap-6">
            {content?.mission && (
              <Card className="bg-slate-800/50 backdrop-blur-sm border-slate-700">
                <CardContent className="p-6">
                  <h3 className="text-xl font-bold text-cyan-400 mb-3">Nuestra Misión</h3>
                  <p className="text-slate-300">{content.mission}</p>
                </CardContent>
              </Card>
            )}
            {content?.vision && (
              <Card className="bg-slate-800/50 backdrop-blur-sm border-slate-700">
                <CardContent className="p-6">
                  <h3 className="text-xl font-bold text-cyan-400 mb-3">Nuestra Visión</h3>
                  <p className="text-slate-300">{content.vision}</p>
                </CardContent>
              </Card>
            )}
          </div>
        )}

        {/* Features */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {features.map((feature) => (
            <Card key={feature.title} className="bg-slate-800/50 backdrop-blur-sm border-slate-700 hover:border-cyan-500/50 transition-all duration-300 hover:scale-105">
              <CardContent className="p-6 text-center">
                <div className="w-16 h-16 rounded-full bg-gradient-to-br from-cyan-500/20 to-emerald-500/20 flex items-center justify-center mx-auto mb-4">
                  <feature.icon className="h-8 w-8 text-cyan-400" />
                </div>
                <h3 className="text-xl font-bold text-white mb-2">{feature.title}</h3>
                <p className="text-slate-400">{feature.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Values */}
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold text-white text-center mb-8">Nuestros Valores</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <Card className="bg-slate-800/50 backdrop-blur-sm border-slate-700">
              <CardContent className="p-6">
                <h3 className="text-xl font-bold text-cyan-400 mb-3">Calidad</h3>
                <p className="text-slate-300">Usamos repuestos de primera calidad y herramientas profesionales.</p>
              </CardContent>
            </Card>
            <Card className="bg-slate-800/50 backdrop-blur-sm border-slate-700">
              <CardContent className="p-6">
                <h3 className="text-xl font-bold text-cyan-400 mb-3">Transparencia</h3>
                <p className="text-slate-300">Presupuestos claros sin sorpresas ni costos ocultos.</p>
              </CardContent>
            </Card>
            <Card className="bg-slate-800/50 backdrop-blur-sm border-slate-700">
              <CardContent className="p-6">
                <h3 className="text-xl font-bold text-cyan-400 mb-3">Confianza</h3>
                <p className="text-slate-300">Miles de clientes satisfechos respaldan nuestro trabajo.</p>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
